<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0016_device_embedded_information_pegging2</div>
        <app-header>esma</app-header>
        <div :class="'container ' +pageContainerSize">
          <title-and-search title="証書情報（紐付選択）"></title-and-search>
          <search-control 
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
          <ag-grid-vue style="width: 100%; height: 230px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <div style="margin-top:5px;">
             <button class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;" @click="backToList">＜　戻る</button>
             <button :disabled="selected_row == -1" class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;" @click="CheckToList">紐付</button>
            </div>
          </div>
          <!-- <button :disabled="selected_row == -1" class="btn btn-danger btn-xs" style="float: right;margin-left: 10px;" @click="onDelete">抹消</button>
          <button :disabled="selected_row == -1" class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;"  @click="onEdit">編集</button> -->
          </div>
</template>

<script>
import Vue from 'vue';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_certificate_information';
import { utils } from '@/libs/utils';


import _debug from 'debug';
var mdebug = _debug('esma:certificate_information');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      api_name:"certificate_information",
      page_acl: acl.generic,
      detail_page:"page_0040_certificate_information_detail"
    };
  },
  computed: {
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.registration_date, {}),
        utils.extend(fields.approval_status, {}),
        utils.extend(fields.certificate_management_number, {}),
        utils.extend(fields.license_jurisdiction_team, {}),
        utils.extend(fields.jurisdiction_classification, {}),
        utils.extend(fields.license_jurisdiction_system, {}),
        utils.extend(fields.licensed_department, {}),
        utils.extend(fields.maker, {}),
        utils.extend(fields.license_name, {}),
        utils.extend(fields.effective_number, {}),
        utils.extend(fields.remaining_number, {}),
      ];
    }
  },
  methods: {
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: {  seq_id:data.seq_id} });
    },
    addNew(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:"new"} });
    },
    backToList(){
      return this. $router.go (-1);
    },
    CheckToList(ev, data){
      return this. $router.go (-2);
    },
     onEdit(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:this.selected_row,cmd:"edit"} });
     },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:true})
    },
    onRowSelected(ev){
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource();
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0016_device_embedded_information_pegging2.vue?39229d7d